export const ActionTypes = {
  FETCH_ALL: 'services/positions/fetch_all',
  FETCH_ALL_BY_LINE_ID: 'services/positions/fetch_all_by_line_id',
  SET_ALL_BY_LINE_ID: 'services/positions/set_all_by_line_id',
  SET_ALL: 'services/positions/set_all',
  ADD_OR_UPDATE_POSITION: 'services/positions/add_or_update_position',
  SET_LOADER_STATUS: 'services/positions/set_loader_status',
  DELETE_POSITION: 'services/positions/delete_line',
  CHANGE_POSITION_ORDER: 'services/positions/change_position_order',
};

const fetchAll = ({ positionParams }) => ({
  positionParams,
  type: ActionTypes.FETCH_ALL,
});

const fetchAllLinePositions = ({ lineId }) => ({
  lineId,
  type: ActionTypes.FETCH_ALL_BY_LINE_ID,
});

const setAllLinePositions = ({ linePositions }) => ({
  linePositions,
  type: ActionTypes.SET_ALL_BY_LINE_ID,
});

const setAll = ({ allPosition }) => ({
  allPosition,
  type: ActionTypes.SET_ALL,
});

const addorUpdatePosition = ({ positionData, actionName, positionParams }) => ({
  positionData,
  actionName,
  positionParams,
  type: ActionTypes.ADD_OR_UPDATE_POSITION,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const deletePosition = ({ id, positionParams, callback }) => ({
  id,
  positionParams,
  callback,
  type: ActionTypes.DELETE_POSITION,
});
const changePositionOrder = ({ fromPositionId, toPositionId, sortAction, callback }) => ({
  fromPositionId,
  toPositionId,
  sortAction,
  callback,
  type: ActionTypes.CHANGE_POSITION_ORDER,
});

export default {
  fetchAll,
  fetchAllLinePositions,
  addorUpdatePosition,
  setAllLinePositions,
  setAll,
  setLoader,
  deletePosition,
  changePositionOrder,
};
